import { api } from '@/api/api';
const URL_GET_SB_BASE = '/fgw/mail-security-access/external/prvlg/status';
const URL_CHECK_URL = '/fgw/mail-security-access/external/check/mail/url';
const URL_GET_SB_ACCESS = '/fgw/mail-security-access/external/prvlg/getAccessTimes';
const SB_HEADERS = { product: 'weblingxi' };
class SafeBrowsingApiImpl {
    constructor() {
        this.name = 'safeBrowsingApiImpl';
        this.httpApi = api.getDataTransApi();
    }
    init() {
        return this.name;
    }
    async _post(url, body) {
        var _a, _b;
        const res = await this.httpApi.post(url, body || {}, {
            contentType: 'json',
            headers: SB_HEADERS,
        });
        const payload = res === null || res === void 0 ? void 0 : res.data;
        if (!payload) {
            throw new Error(`SafeBrowsing empty response: ${url}`);
        }
        const codeRaw = payload.code;
        const code = typeof codeRaw === 'string' ? parseInt(codeRaw, 10) : codeRaw;
        if (code !== 200) {
            const desc = payload.message || payload.msg || payload.error || '';
            throw new Error(`SafeBrowsing biz code ${codeRaw} ${desc} (${url})`);
        }
        return ((_b = (_a = payload.result) !== null && _a !== void 0 ? _a : payload.data) !== null && _b !== void 0 ? _b : {});
    }
    getSbBase() {
        return this._post(URL_GET_SB_BASE);
    }
    checkUrl(req) {
        const body = { url: req.url };
        if (req.mid) {
            body.mid = req.mid;
        }
        return this._post(URL_CHECK_URL, body);
    }
    getSbAccess(req) {
        const body = { checkType: req.checkType };
        if (req.url)
            body.url = req.url;
        if (req.fileKey)
            body.fileKey = req.fileKey;
        if (req.mid)
            body.mid = req.mid;
        if (req.partId)
            body.partId = req.partId;
        return this._post(URL_GET_SB_ACCESS, body);
    }
}
const safeBrowsingApiImpl = new SafeBrowsingApiImpl();
api.registerLogicalApi(safeBrowsingApiImpl);
export default safeBrowsingApiImpl;
